import React, { Component, Fragment } from 'react';
import ReactDatatable from '@ashvin27/react-datatable';

class PaginationDefault extends Component {
    constructor(props) {
        super(props);
        this.columns = [
            {
                key: "name",
                text: "Name",
                sortable: true,
                cell: (record, index) => {
                    return (
                        <Fragment>
                            <a href={`https://crm.uniacco.com/leads/${record.id}`} target="_blank">{record.name}</a>
                        </Fragment>
                    )
                }
            },
            {
                key: "email",
                text: "Email",
                sortable: true
            },
            {
                key: "phone",
                text: "Phone",
                sortable: true
            },
            {
                key: "status",
                text: "Status",
                sortable: true
            },
            {
                key: "updated_at",
                text: "Updated at"
            }
        ];

        this.config = {
            page_size: 10,
            length_menu: [10, 20, 50],
            show_filter: false, 
            show_pagination: true,
            pagination: 'advance',
            button: {
                excel: false,
                print: false
            }
        }
        this.state = {
            records: this.props.response
        }
    }

    render() {
        return (<ReactDatatable
            config={this.config}
            records={this.props.response}
            columns={this.columns}
            onChange={(obj) => {
                // obj has 4 keys - filter_value, page_number, page_size, sort_order
                this.props.onPageChange(obj.page_number, obj.page_size);
            }}
            total_record={this.props.count}
            dynamic={true}
            />
        );
    }
}

export default PaginationDefault;